import {Component, OnInit, Input} from '@angular/core';
import {HelperService} from "@app/services/helper/helper.service";
import {Task} from "@app/interfaces/task";

export interface Board {
    _id: string,
    project_id: string,
    columns: any[],
    name: string,
    status: string,
    sprints?: any[],
    tasks: [],
    projectData: {},
    createdAt: string,
    type: string
}

@Component({
    selector: 'app-board-card',
    templateUrl: './board-card.component.html',
    styleUrls: ['./board-card.component.css']
})
export class BoardCardComponent implements OnInit {

    constructor(private helperService: HelperService) {
    }

    @Input() boardData;
    board: Board;
    dateCreated: string;
    percent: number = 50;
    doneTasksNumber: number = 0;

    ngOnInit(): void {
        this.board = {
            _id: this.boardData['_id'],
            project_id: this.boardData['project_id'],
            columns: this.boardData['columns'],
            name: this.boardData['name'],
            status: this.boardData['status'],
            sprints: [], // ovako moze da stoji jer nije bitno za ovu karticu
            tasks: this.boardData['tasks'],
            projectData: this.boardData['projectData'],
            createdAt: this.boardData['created_at'],
            type: this.boardData['type']
        };
        this.dateCreated = this.helperService.getStringDateFormat(this.board.createdAt);
        this.percent = this.board.tasks.length;
        let total = 0;
        this.board.tasks.map((item: Task) => {
            if (item.status === 'ddone') {
                total = total + 1;
            }
        });
        this.doneTasksNumber = total;
        this.percent = Math.floor((total / this.board.tasks.length) * 100);

    }

    setStyles() {
        let styles = {'width': this.percent + '%'};
        return styles;
    }
}
